import { Calendar } from "fullcalendar";

export default function initEventsCalendar() {
  const isPresent = document.getElementById("calendar");

  if (!isPresent) {
    return;
  }

  const calendarEl = document.getElementById("calendar");
  const eventsData = JSON.parse(calendarEl.getAttribute("data-events"));

  const formattedEventsData = eventsData.map((event) => {
    const hasTime = event.start && event.start.includes("T");
    const startDate = new Date(event.start);
    let endDate = event.end ? new Date(event.end) : null;

    if (endDate && startDate < endDate && !event.allDay) {
      endDate.setDate(endDate.getDate() + 1);
    }

    return {
      ...event,
      start: startDate,
      end: endDate,
      allDay: event.allDay || !hasTime,
    };
  });

  function getInitialView() {
    return window.innerWidth >= 1024 ? "dayGridMonth" : "listMonth";
  }

  function getAspectRatio() {
    return window.innerWidth >= 1024 ? 1 : "auto";
  }

  const calendar = new Calendar(calendarEl, {
    locale: "et",
    firstDay: 1,
    aspectRatio: getAspectRatio(),
    headerToolbar: {
      left: "",
      center: "prev,title,next",
      right: "",
    },
    initialDate: new Date(),
    navLinks: true,
    businessHours: true,
    editable: false,
    eventStartEditable: false,
    selectable: true,
    events: formattedEventsData,
    eventTimeFormat: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    },
    allDayText: "",
    initialView: getInitialView(),
    noEventsContent: "Sel kuul sündmusi ei ole",
    eventClick: function (info) {
      info.jsEvent.preventDefault();

      if (info.event.extendedProps.content && info.event.url) {
        window.location.href = info.event.url;
      }
    },
    eventDidMount: function (info) {
      if (!info.event.extendedProps.content) {
        info.el.classList.add("no-link");
      }
    },
    dayCellDidMount: function (info) {
      var date = new Date(info.date);
      var monthName = date.toLocaleString("et-EE", { month: "long" });
      var dayNumberEl = info.el.querySelector(".fc-daygrid-day-number");
      if (dayNumberEl) {
        var monthEl = document.createElement("div");
        monthEl.className = "fc-daygrid-day-month";
        monthEl.innerText = monthName;
        dayNumberEl.appendChild(monthEl);
      }
    },
    eventContent: function (arg) {
      const isMobile = window.innerWidth < 1024;
      const eventTitle = arg.event.title;

      const hasTime = arg.event.startStr.includes("T");
      let timeText = "";

      if (hasTime) {
        const eventDate = new Date(arg.event.start);
        timeText = eventDate.toLocaleTimeString("et-EE", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
      }

      if (isMobile && timeText) {
        return {
          html: `<div class="fc-event-title">${timeText}: ${eventTitle}</div>`,
        };
      } else if (timeText) {
        return {
          html: `<div class="fc-event-time">${timeText}</div><div class="fc-event-title">${eventTitle}</div>`,
        };
      } else {
        return {
          html: `<div class="fc-event-title">${eventTitle}</div>`,
        };
      }
    },
    windowResize: function () {
      if (window.innerWidth < 1024) {
        calendar.changeView("listMonth");
        calendar.setOption("aspectRatio", "auto");
      } else {
        calendar.changeView("dayGridMonth");
        calendar.setOption("aspectRatio", 1);
      }
    },
  });

  calendar.render();
}
